import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FirebaseService } from './firebase.service';
import { HttpClient } from '@angular/common/http';

export type ApiKey = {
  id: string;
  api_key: string;
  tenant_id: string;
  created_at: string;
  deleted: boolean;
  deleted_at?: string;
  deleted_by?: string;
};

export type CreateApiKeyRequest = {
  tenant_id: string;
  api_key: string;
};

export type DeleteApiKeyResponse = {
  message: string;
};

@Injectable({
  providedIn: 'root',
})
export class ApiKeysService {
  private getApiKeyByTenantIdUrl = environment.serverUrl + '/api-keys/for-tenant';
  private createApiKeyUrl = environment.serverUrl + '/api-keys/create';
  private deleteApiKeyUrl = environment.serverUrl + '/api-keys/delete';

  constructor(
    private firebaseService: FirebaseService,
    private http: HttpClient
  ) {}

  getApiKeyByTenantId(tenantId: string) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.get<ApiKey | null>(
          this.getApiKeyByTenantIdUrl + '/' + tenantId,
          {
            headers: { Authorization: 'Bearer ' + token },
          }
        );
      })
    );
  }

  createApiKey(request: CreateApiKeyRequest) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.post<ApiKey>(this.createApiKeyUrl, request, {
          headers: { Authorization: 'Bearer ' + token },
        });
      })
    );
  }

  deleteApiKey(id: string) {
    return this.firebaseService.idToken().pipe(
      mergeMap((token) => {
        return this.http.delete<DeleteApiKeyResponse>(
          this.deleteApiKeyUrl + '/' + id,
          {
            headers: { Authorization: 'Bearer ' + token },
          }
        );
      })
    );
  }
}
